import { AxiosInstance } from 'axios';

import { avatarEndpoints } from '../../utils/constants';
import { axios } from '../axiosInstance';

import { UpdateUserAvatarInput } from './UserAvatarApi.schema';

class UserAvatarApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  create = async (input: FormData) => {
    return this.#requestInstance.post(avatarEndpoints.postAvatar, input);
  };

  remove = async (id: number): Promise<void> => {
    return this.#requestInstance.delete(avatarEndpoints.getAvatarById(id));
  };

  update = async (input: UpdateUserAvatarInput) => {
    return this.#requestInstance.patch(avatarEndpoints.getAvatarById(input.id), input.formData);
  };

  getAvatars = async (): Promise<any> => {
    return this.#requestInstance.get(avatarEndpoints.allAvatars);
  };
}

export const userAvatarApi = new UserAvatarApi(axios);
